var _rect, _path, _path2, _path3, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.53125,
    y: 3.92041,
    width: 7.9375,
    height: 4.1875,
    rx: 2,
    stroke: "#604136",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11.1704H22.25V19.4954C22.25 20.4895 21.4441 21.2954 20.45 21.2954H4.55C3.55589 21.2954 2.75 20.4895 2.75 19.4954V11.1704Z",
    fill: "#604136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.15791C2.75 7.1638 3.55589 6.35791 4.55 6.35791H20.45C21.4441 6.35791 22.25 7.1638 22.25 8.15791V12.0142H2.75V8.15791Z",
    fill: "#795548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.9411C22.25 12.3667 17.8848 13.6704 12.5 13.6704C7.11522 13.6704 2.75 12.3667 2.75 11.9411C2.75 11.5155 7.11522 11.1704 12.5 11.1704C17.8848 11.1704 22.25 11.5155 22.25 11.9411Z",
    fill: "#795548"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1875,
    y: 12.0142,
    width: 2.625,
    height: 4.0625,
    rx: 0.6,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4688,
    y: 13.4673,
    width: 4.06,
    height: 1.00781,
    rx: 0.503906,
    fill: "#7C7370"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.b54de9afcb830d2833f1691d1eb44b6d.svg";
export { ForwardRef as ReactComponent };